import { memo } from "react";
import { IItemFiltro, itensFiltro } from "../ModeloViagens.contants.ts";
import React from "react";
import Icon from "../../../../core/components/Icon.tsx";
import "../ModeloViagens.css";
import IconButton from "../../../../core/components/IconButton.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import useOutsideClick from "../../../../hooks/useOutsideClick.ts";

interface FiltroEmbarqueTemplateProps {
	buscarSearch: () => void;
	filtroSelecionado: IItemFiltro | undefined;
	setFiltroSelecionado: (params: IItemFiltro | undefined) => void;
	setValuesPesquisa: (params: any) => void;
	valuesPesquisa: any;
	handleClearPesquisa: () => void;
}

interface FiltrarPorBoxProps {
	setFiltroSelecionado: (params: IItemFiltro) => void;
	handleClearPesquisa: () => void;
	filtroSelecionado: IItemFiltro | undefined;
}

interface FiltrarSearchBoxProps {
	buscarSearch: () => void;
	valuesPesquisa: any;
	setValuesPesquisa: (params: any) => void;
}

function FiltrarPorBox({
	setFiltroSelecionado,
	handleClearPesquisa,
	filtroSelecionado,
}: FiltrarPorBoxProps) {
	const [openFiltrar, toggleFiltrar, , refFiltrar] = useOutsideClick();

	return (
		<div
			className="filtrar-por-container"
			onClick={toggleFiltrar}
			ref={refFiltrar}
		>
			<Icon name="Filter" size="lg" theme="dark" />
			<Separator direction="horizontal" size="sm" />
			{openFiltrar && (
				<div className="select-options">
					<div
						className="option2"
						onClick={() => {
							handleClearPesquisa();
						}}
					>
						<b>Filtrar</b>
					</div>
					{itensFiltro.map((item) => (
						<div
							className={
								item.field === filtroSelecionado?.field
									? "option selected"
									: "option"
							}
							key={item.field}
							onClick={() => {
								setFiltroSelecionado(item);
							}}
						>
							{item.nomeColuna}
						</div>
					))}
				</div>
			)}
			<b>Filtrar Por: </b>
			<Separator direction="horizontal" size="xs" />
			<b>{filtroSelecionado?.nomeColuna}</b>
		</div>
	);
}

function FiltrarSearchBox({
	buscarSearch,
	valuesPesquisa,
	setValuesPesquisa,
}: FiltrarSearchBoxProps) {
	return (
		<div className="template-search-box">
			<input
				type="text"
				placeholder="Pesquisar"
				value={valuesPesquisa}
				onChange={(e) => setValuesPesquisa(e.target.value)}
				onKeyDown={e => {
					if (e.key === 'Enter') {
					e.preventDefault();
					buscarSearch();
					}
				}}
			/>
			<IconButton
				onClick={() => buscarSearch()}
				icon="Search"
				size="lg"
				theme="dark"
			/>
		</div>
	);
}

function FiltroEmbarqueTemplate({
	buscarSearch,
	filtroSelecionado,
	setFiltroSelecionado,
	setValuesPesquisa,
	valuesPesquisa,
	handleClearPesquisa,
}: FiltroEmbarqueTemplateProps) {
	return (
		<div className="filtro-embarque-template">
			<FiltrarPorBox
				setFiltroSelecionado={setFiltroSelecionado}
				handleClearPesquisa={handleClearPesquisa}
				filtroSelecionado={filtroSelecionado}
			/>
			<Separator direction="horizontal" size="md" />
			<FiltrarSearchBox
				buscarSearch={buscarSearch}
				valuesPesquisa={valuesPesquisa}
				setValuesPesquisa={setValuesPesquisa}
			/>
			<Separator direction="horizontal" size="md" />
			<IconButton
				icon="X"
				onClick={handleClearPesquisa}
				theme="dark"
				size="lg"
			/>
		</div>
	);
}

export default memo(FiltroEmbarqueTemplate);
